import React from 'react';
import {
  Divider,
  Segment,
  Grid,
} from 'semantic-ui-react';
import ThemeSelector from '../../themes/theme-selector';

const theme = ThemeSelector.theme();

const logoStyle = {
  display: 'block',
  margin: '50px auto 30px auto',
  maxWidth: '70%',
};

const UnsubscribeConfirmation = () => (
  <div className="page">
    <div className="page-content">
      <a href="/"><img style={logoStyle} src="/themes/theme/elemis/logo.png" alt={theme.darkLogo.alt} /></a>
      <Grid container>
        <Grid.Row>
          <Grid.Column only="computer" computer="3" />
          <Grid.Column computer="10" mobile="16">
            <Segment textAlign="center" size="small">
              <h1 style={{ textAlign: 'center' }}>
               Unsubscribed successfully
              </h1>
              <Divider />
              <p className="info">You have been unsubscribed from our Elemis Influencer outreach program</p>
            </Segment>
          </Grid.Column>
        </Grid.Row>
        <Grid.Column only="computer" computer="3" />
      </Grid>
    </div>
  </div>
);


export default UnsubscribeConfirmation;



/** WEBPACK FOOTER **
 ** ./src/containers/unsubscribe-confirmation/index.js
 **/